import { FormattedMessage as FM } from "react-intl";

import { cn } from "tools/ui";
import ListError from "./ListError";
import ListField from "./ListField";
import {
  STYLE_ACTION_BUTTON,
  STYLE_ACTION_BUTTON_PRIMARY,
} from "../constants";

function ListItemForm({
  fields,
  form,
  error,
  saving,
  onChange,
  onSave,
  onCancel,
  children,
}) {
  function handleSubmit(event) {
    event.preventDefault();
    onSave();
  }

  return (
    <div className="space-y-4 rounded-md border border-sky-200 bg-sky-50/40 p-3">
      <form noValidate onSubmit={handleSubmit} className="space-y-3">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {fields.map((field) => (
            <div
              key={field.name}
              className={cn("min-w-0", field.wide && "sm:col-span-2")}
            >
              <ListField
                field={field}
                value={form[field.name]}
                onChange={onChange}
              />
            </div>
          ))}
        </div>
        <ListError error={error} />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            disabled={saving}
            onClick={onCancel}
            className={`${STYLE_ACTION_BUTTON} min-h-11 disabled:opacity-50`}
          >
            <FM id="melhous.dash.list.cancel" />
          </button>
          <button
            type="submit"
            disabled={saving}
            className={`${STYLE_ACTION_BUTTON_PRIMARY} min-h-11 disabled:opacity-50`}
          >
            <FM id={saving ? "melhous.dash.list.saving" : "melhous.dash.list.save"} />
          </button>
        </div>
      </form>
      {children}
    </div>
  );
}

export default ListItemForm;
